module.exports = __webpack_public_path__ + "img/object-mark7.699e810e.png";